import React from 'react';
import PropTypes from 'prop-types';
import './CategoryHeader.css';

// Simple SVG icon components
const Icons = {
  UtensilsCrossed: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="m16 2-2.3 12.3" />
      <path d="M17.9 3.7c.7.7 1.1 1.6 1.1 2.5 0 1.8-1.4 3.3-3.2 3.3S12.6 7.9 12.6 6c0-.9.4-1.8 1.1-2.5" />
      <path d="m6 2 1.8 6.8" />
      <path d="M10.5 7 9 2" />
      <path d="m7 22 3.5-12.5" />
      <path d="m13 22-3.5-12.5" />
    </svg>
  ),
  ShoppingBag: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
      <path d="M3 6h18" />
      <path d="M16 10a4 4 0 0 1-8 0" />
    </svg>
  ),
  Coffee: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 8h1a4 4 0 1 1 0 8h-1" />
      <path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z" />
      <line x1="6" x2="6" y1="2" y2="4" />
      <line x1="10" x2="10" y1="2" y2="4" />
      <line x1="14" x2="14" y1="2" y2="4" />
    </svg>
  ),
  Briefcase: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  Store: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7" />
      <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
      <path d="M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4" />
      <path d="M2 7h20" />
      <path d="M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7" />
    </svg>
  ),
  Stethoscope: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3" />
      <path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4" />
      <circle cx="20" cy="10" r="2" />
    </svg>
  ),
  GraduationCap: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
      <path d="M6 12v5c3 3 9 3 12 0v-5" />
    </svg>
  ),
  Home: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
};

const CategoryHeader = ({ category, stats }) => {
  // Get the icon component or use a default
  const IconComponent = Icons[category.icon] || Icons.ShoppingBag;
  
  return (
    <header className="category-header">
      <div className="category-header-content">
        <div className="category-brand">
          <div className="category-icon" style={{ backgroundColor: category.color }}>
            <div className="icon-emoji">
              <IconComponent />
            </div>
          </div>
          <div className="category-text">
            <h1 className="category-title">{category.name}</h1>
            <p className="category-subtitle">{category.description}</p>
       </div>
       </div>
        
        <div className="category-stats">
          <div className="stat-item">
            <span className="stat-number">{stats.businessCount}</span>
            <span className="stat-label">Businesses</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">{stats.avgRating}</span>
            <span className="stat-label">Avg Rating</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">{stats.verifiedCount}</span>
            <span className="stat-label">Verified</span>
          </div>
        </div>
      </div>
      
      <div className="category-header-overlay"></div>
    </header>
  );
};

CategoryHeader.propTypes = {
  category: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired, // Icon name: 'UtensilsCrossed', 'Coffee', 'ShoppingBag', etc.
    color: PropTypes.string.isRequired
  }).isRequired,
  stats: PropTypes.shape({
    businessCount: PropTypes.number.isRequired,
    avgRating: PropTypes.string.isRequired,
    verifiedCount: PropTypes.number.isRequired
  }).isRequired
};

export default CategoryHeader;